import {
  DELETE_AVAILABLE_STALL_FAILURE,
  DELETE_AVAILABLE_STALL_REQUEST,
  DELETE_AVAILABLE_STALL_RESET,
  DELETE_AVAILABLE_STALL_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const deleteAvailableStallReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_AVAILABLE_STALL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case DELETE_AVAILABLE_STALL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Stall deleted successfully",
      }

    case DELETE_AVAILABLE_STALL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case DELETE_AVAILABLE_STALL_RESET:
      return { ...initialState }

    default:
      return state
  }
}

export default deleteAvailableStallReducer
